import { Controller } from 'stimulus';

class NavigationController extends Controller {
  onTogglerClick({ currentTarget }) {
    const isOpen = currentTarget.getAttribute('aria-expanded') === 'true';

    this.navigationTarget.classList.toggle('is-open', !isOpen);
  }
}

NavigationController.targets = [
  'navigation',
];

export default NavigationController;
